import type { Config } from 'tailwindcss';

export default {
  content: [
    './index.html',
    './src/**/*.{vue,js,ts,jsx,tsx}',
    './lib/forms/src/**/*.{vue,js,ts,jsx,tsx}',
    './packages/vue-components/lib/**/*.{vue,js,ts,jsx,tsx}',
  ],
  theme: {
    extend: {
      colors: {
        primary: 'var(--vp-primary)',
        'primary-selection': 'var(--vp-primary-selection)',
        content: 'var(--vp-content)',
        'content-muted': 'var(--vp-content-muted)',
        surface: 'var(--vp-surface)',
        'surface-muted': 'var(--vp-surface-muted)',
        error: 'var(--vp-error)',
        secondary: 'var(--vp-secondary)',
        'text-muted': 'var(--vp-text-muted)',
      },
    },
  },
  plugins: [],
  corePlugins: {
    backgroundOpacity: false,
  },
} satisfies Config;
